module.exports = __webpack_public_path__ + "img/AZ.b02e1d89.svg";